import CentroTrabajoService from '../../services/CentroTrabajoService'

export default {
  namespaced: true,
  state: {
    centrosTrabajo: [],
    centroTrabajo: null,
    totalItems: 0,
    currentPage: 1
  },
  getters: {
    centrosTrabajo: state => state.centrosTrabajo,
    centroTrabajo: state => state.centroTrabajo,
    totalItems: state => state.totalItems,
    currentPage: state => state.currentPage
  },
  mutations: {
    setCentrosTrabajo(state, centrosTrabajo) {
      state.centrosTrabajo = centrosTrabajo
    },
    setCentroTrabajo(state, centroTrabajo) {
      state.centroTrabajo = centroTrabajo
    },
    setTotalItems(state, totalItems) {
      state.totalItems = totalItems
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage
    }
  },
  actions: {
    async fetchCentrosTrabajo({ commit }, { page = 1, limit = 15, filters = {} }) {
      try {
        const response = await CentroTrabajoService.getCentrosTrabajo(page, limit, filters)
        commit('setCentrosTrabajo', response.data.data)
        commit('setTotalItems', response.data.total)
        commit('setCurrentPage', page)
        return response
      } catch (error) {
        console.error('Error fetching centros de trabajo:', error)
        throw error
      }
    },
    async fetchAllCentrosTrabajo({ commit }, filters = {}) {
      try {
        const response = await CentroTrabajoService.getAllCentrosTrabajo(filters)
        return response
      } catch (error) {
        console.error('Error fetching all centros de trabajo:', error)
        throw error
      }
    },
    async fetchCentroTrabajo({ commit }, id) {
      try {
        const response = await CentroTrabajoService.getCentroTrabajo(id)
        commit('setCentroTrabajo', response.data.data)
        return response
      } catch (error) {
        console.error('Error fetching centro de trabajo:', error)
        throw error
      }
    },
    async createCentroTrabajo({ dispatch }, centroTrabajo) {
      try {
        const response = await CentroTrabajoService.createCentroTrabajo(centroTrabajo)
        return response
      } catch (error) {
        console.error('Error creating centro de trabajo:', error)
        throw error
      }
    },
    async updateCentroTrabajo({ dispatch }, { id, centroTrabajo }) {
      try {
        const response = await CentroTrabajoService.updateCentroTrabajo(id, centroTrabajo)
        return response
      } catch (error) {
        console.error('Error updating centro de trabajo:', error)
        throw error
      }
    },
    async deleteCentroTrabajo({ dispatch }, id) {
      try {
        const response = await CentroTrabajoService.deleteCentroTrabajo(id)
        return response
      } catch (error) {
        console.error('Error deleting centro de trabajo:', error)
        throw error
      }
    }
  }
}